// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaGithub, FaEnvelope, FaTwitter, FaFacebookF } from "react-icons/fa";
import "../Styles/Footer.css";
import "../Styles/share-buttons.css";
const currentYear = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content-wrapper">
        {/* === Section 1: Brand and Copyright === */}
        <div className="footer-section brand-info">
          <Link to="/" className="footer-logo">
            Dewitt Solutions
          </Link>
          <p className="tagline">
            <b>
              Turning complex ideas into simple, high-performance digital
              realities.
            </b>
          </p>
          <p className="copyright">
            &copy; {currentYear} Dewitt Solutions LLC. All rights reserved.
          </p>
        </div>

        {/* === Section 2: Quick Links === */}
        <div className="footer-section links-nav">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/web-development">Web Development</Link></li>
            <li><Link to="/capabilities">Capabilities</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/case-studies">Case Studies</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* === Section 3: Social/Contact Info === */}
        <div className="footer-section social-contact">
          <h4>Connect & Share</h4>
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/company/dewitt-solutions-llc/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn Profile"
            >
              <FaLinkedin size={24} />
            </a>
            <a
              href="https://github.com/DeWittSolutionsLLC"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub Repository"
            >
              <FaGithub size={24} />
            </a>
          </div>
          <p className="email-contact">
            Email: <a href="mailto:dewitt.solutionsllc26@gmail.com">dewitt.solutionsllc26@gmail.com</a>
          </p>
          <div className="share-section">
            <h5>Share this page</h5>
            <div className="share-buttons">
              <a
                href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fdewitt-solutions.com&text=Custom%20React%20Web%20Development%20Agency"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Share on Twitter"
                className="share-btn twitter"
              >
                <FaTwitter size={20} />
              </a>
              <a
                href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdewitt-solutions.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Share on Facebook"
                className="share-btn facebook"
              >
                <FaFacebookF size={20} />
              </a>
              <a
                href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fdewitt-solutions.com&title=DeWitt%20Solutions%20%E2%80%94%20Custom%20React%20Web%20Development"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Share on LinkedIn"
                className="share-btn linkedin"
              >
                <FaLinkedin size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
